export default {
  props: {
    header: {
      type: String
    },
    testimonials: {
      type: Array
    },
    styles: {
      type: Object
    },
    testimonialsStyles: {
      type: Object
    },
    starColor: {
      type: String
    }
  },
  data() {
    return {
      readMore: {},
      swiper: null,
      swiperOptions: {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 'auto',
        autoplay: {
          delay: 4000,
          disableOnInteraction: true
        }
      }
    };
  },
  head() {
    return {
      link: [{
        rel: 'stylesheet',
        type: 'text/css',
        href: 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css'
      }],
      script: [{
        src: 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js'
      }]
    };
  },
  computed: {
    starFill() {
      if (!this.starColor) return '#FFC700';
      return this.starColor;
    },
    activateSwipe() {
      if (this.testimonials.length > 3) return true;else return false;
    }
  },
  mounted() {
    if (this.activateSwipe) {
      this.swiper = new window.Swiper('.testimonials', {
        ...this.swiperOptions,
        wrapperClass: 'testimonial-wrapper',
        slideClass: 'testimonial-card'
      });
    }
  },
  methods: {
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    }
  }
};